import {invalid} from "@codeArt/utils/common";
import _ from "lodash";
export function toByteSize(value){
  if (value === 0) return "0 B";
  let size = "";
  if (value < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = value.toFixed(2) + "B";
  } else if (value < 0.1 * 1024 * 1024) {
    //小于0.1MB，则转化成KB
    size = (value / 1024).toFixed(2) + "K";
  } else if (value < 0.1 * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB
    size = (value / (1024 * 1024)).toFixed(2) + "M";
  } else {
    //其他转化成GB
    size = (value / (1024 * 1024 * 1024)).toFixed(2) + "G";
  }

  let sizeStr = size + ""; //转成字符串
  let index = sizeStr.indexOf("."); //获取小数点处的索引
  let dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
  if (dou === "00") {
    //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
  }
  return size;
}

export function twoDecimal(x,pad){ //pad:是否补0
  try {
    let x1 = parseFloat(x);
    if (isNaN(x1)) {
      return x;
    }
    let f_x = Math.round(x * 100) / 100;
    let s_x = f_x.toString();
    let pos_decimal = s_x.indexOf(".");
    if (pos_decimal < 0) {
      pos_decimal = s_x.length;
      s_x += ".";
    }
    while (s_x.length <= pos_decimal + 2) {
      s_x += "0";
    }
    return pad === true ? s_x : parseFloat(s_x);
  } catch (e) {
    return pad === true ? "0.00":0;
  }
}

//将浮点数四舍五入，取小数点后2位   
export function twoDecimalFloat(x) {   
  var f = parseFloat(x);   
  if (isNaN(f)) return; 
  f = Math.round(x*100)/100;   
  return f;   
}   

export function threePosition(n){
  if (invalid(n)) return;
  let b = parseInt(n).toString();
  let len = b.length;
  if (len <= 3) {
    return b;
  }
  let r = len % 3;
  return r > 0
    ? b.slice(0, r) + "," + b.slice(r, len).match(/\d{3}/g).join(",")
    : b.slice(r, len).match(/\d{3}/g).join(",");
}



export function hasFlag(value,flag){
  let v = parseInt(value).toString(2);
  let f = parseInt(flag).toString(2).trimStart("0");
 
  if(f.length > v.length) return false;
  return v[v.length-f.length]=="1";
}